import { post } from '@/request';

const wxApi = {
  accessToken(data) {
    return post('/nfm/wx/zlb/accessToken', data);
  },
  getInfo(data) {
    return post('/nfm/wx/zlb/getInfo', data);
  }
};
export default wxApi;
